// Module
var code = "<div> <EpToolbar :editor=\"editor\" :features=\"features\"/> <EpEditor ref=\"editorComponent\" :features=\"features\" :placeholder=\"placeholder\" :template=\"template\" :html=\"html\" @change=\"onChange\"/> </div>";
// Exports
module.exports = code;